<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 智慧物管上 -->
      <el-row>
        <el-col :span="24" class="scene_top">
          <div class="scene_topContent">
            <h1>智慧物管</h1>
            <ul>
              <li>
                <span>可视</span
                >动态、直观的数字孪生技术对建筑设备进行全方位监测
              </li>
              <li><span>可管</span>客服、设备、工单、巡检实时在线</li>
              <li><span>可控</span>主动预警、即时响应、进度可查</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <!-- 业务痛点 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space scene_parkBusiness">
            <div class="title" style="margin-left: 94px">
              <h3>业务痛点</h3>
            </div>
            <el-row>
              <el-col :span="24">
                <div class="businessPainPoints">
                  <div class="businessPainPoints_left">
                    <div class="content businessPainPoints_leftTop">
                      <h4>效率难以提升</h4>
                      <p>能耗抄表费时费力，准确性和效率低，任务流转不及时</p>
                    </div>
                    <div class="content businessPainPoints_leftBottom">
                      <h4>缺乏依据，经验无法积累</h4>
                      <p>
                        巡检、维修没有统一标准，依靠工作人员自身经验判断，可靠程度低
                      </p>
                    </div>
                  </div>
                  <div
                    class="content_picture content_pictureOne"
                    style="margin-left: 94px"
                  >
                    <img src="~@/assets/images/propertyManagement2.png" />
                  </div>
                  <div class="businessPainPoints_right">
                    <div class="content businessPainPoints_rightTop">
                      <h4>过程难以监控</h4>
                      <p>
                        物业服务依靠人工衔接，服务响应不及时，巡维保过程及结果难以监测
                      </p>
                    </div>
                    <div class="content businessPainPoints_rightBottom">
                      <h4>成本管控混乱</h4>
                      <p>物业采购及仓库管理基本靠手工记录，管理数据混乱</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 物业报修 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space property_repair">
            <div class="title" style="margin-bottom: 50px">
              <h3>物业报修</h3>
              <p>即时响应、快速派单、进度可查</p>
            </div>
            <el-row>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture">
                    <img src="~@/assets/images/propertyManagement3.png" />
                  </div>
                  <h4>一键报修</h4>
                  <p>用户一键报修</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture">
                    <img src="~@/assets/images/propertyManagement4.png" />
                  </div>
                  <h4>快速处理</h4>
                  <p>任务自动分类，快速查询与统计</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture">
                    <img src="~@/assets/images/propertyManagement5.png" />
                  </div>
                  <h4>后台分配</h4>
                  <p>工单指派，直达维修人员</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture">
                    <img src="~@/assets/images/propertyManagement6.png" />
                  </div>
                  <h4>及时维修</h4>
                  <p>维修人员及时处理，过程跟进</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 设备运维 -->
      <el-row>
        <el-col :span="24">
          <div
            class="
              content_space
              equipment_operationMaintenance equipment_operationMaintenances
            "
          >
            <div class="title">
              <h3>设备运维</h3>
              <p>业务管理系统互联互通，多端操作</p>
            </div>
            <el-row>
              <el-col :span="11">
                <div class="content_picture">
                  <img src="~@/assets/images/propertyManagement7.png" />
                </div>
              </el-col>
              <el-col :span="5" style="height: 45px"></el-col>
              <el-col :span="8">
                <el-row>
                  <div class="content">
                    <h4><i></i>设备台账</h4>
                    <p>设备运行参数、状态一目了然</p>
                  </div>
                </el-row>
                <el-row>
                  <div class="content">
                    <h4><i></i>设备维保</h4>
                    <p>保养定时提醒、提前预警故障，减少维修成本</p>
                  </div>
                </el-row>
                <el-row>
                  <div class="content">
                    <h4><i></i>专家知识库</h4>
                    <p>设备保养、维修有据可依</p>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 设备运维 -->
      <el-row>
        <el-col :span="24">
          <div
            class="
              content_space
              equipment_operationMaintenance equipment_operationMaintenanceTwo
            "
          >
            <div class="title">
              <h3>数字化巡逻</h3>
              <p>数字化线上巡逻，轨迹实时监控</p>
            </div>
            <el-row>
              <el-col :span="12">
                <el-row>
                  <div class="content">
                    <h4><i></i>巡逻标准</h4>
                    <p>统一标准，巡逻有据可依，不畏人员流动</p>
                  </div>
                </el-row>
                <el-row>
                  <div class="content">
                    <h4><i></i>线上巡逻</h4>
                    <p>线上实时签到，流程简单，记录有效留存</p>
                  </div>
                </el-row>
                <el-row>
                  <div class="content">
                    <h4><i></i>轨迹监控</h4>
                    <p>实时轨迹跟踪，异常同步告警，有效结合防与管</p>
                  </div>
                </el-row>
                <el-row>
                  <div class="content">
                    <h4><i></i>数据分析</h4>
                    <p>结果数据分析，提升线路合理性和执行效率</p>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="12">
                <div class="content_picture" style="margin-right: 378px">
                  <img src="~@/assets/images/propertyManagement8.png" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    background: url(~@/assets/images/propertyManagement1.png) no-repeat;
    background-size: 100% 100%;
    height: 475px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      position: absolute;
      top: 145px;
      left: 255px;
      text-align: left;
      h1 {
        padding-bottom: 43px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      ul li {
        list-style: none;
        font-size: 18px;
        color: #ffffff;
        font-weight: 400;
        margin-bottom: 32px;
        span {
          font-weight: bold;
          margin-right: 14px;
        }
      }
    }
  }

  // 公共
  .scene_park {
    background: #fff !important;
    padding: 81px 358px 23px 359px !important;
  }

  // 业务痛点
  .scene_parkBusiness {
    background: #fff !important;
    padding: 83px 356px 61px 269px !important;

    .content_pictureOne {
      // width: 515px;
      // height: 302px;
      img {
        width: auto;
        height: auto;
        max-width: 515px;
        max-height: 302px;
      }
    }
    .title {
      h3 {
        margin-bottom: 102px;
      }
    }
    .businessPainPoints {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        margin: 0 0 13px 0 !important;
      }
      .businessPainPoints_left {
        width: 100%;
        text-align: right;
        .businessPainPoints_leftTop {
          position: relative;
          top: -69px;
          left: -29px;
        }
        .businessPainPoints_leftBottom {
          position: relative;
          top: 26px;
          left: -29px;
        }
      }
      .businessPainPoints_right {
        width: 100%;
        text-align: left;
        .businessPainPoints_rightTop {
          position: relative;
          top: -79px;
          right: -128px;
        }

        .businessPainPoints_rightBottom {
          position: relative;
          top: 16px;
          right: -135px;
        }
      }
    }
  }

  //物业保修
  .property_repair {
    padding: 60px 134px 85px 140px;
    .content {
      img {
        width: auto;
        height: auto;
        max-width: 165px;
        max-height: 177px;
      }
    }
  }

  //设备运维
  .equipment_operationMaintenance {
    background: #fff !important;
    padding: 63px 255px 45px 255px;
    .title {
      p {
        margin-bottom: 45px;
      }
    }
    .content {
      text-align: left;
      margin-bottom: 20px !important;
      padding-left: 26%;
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        // font-weight: 400;
        i {
          width: 10px;
          height: 10px;
          background: #fe5f28;
          border-radius: 50%;
          display: inline-block;
          margin-right: 18px;
        }
      }
      p {
        margin-top: 14px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .equipment_operationMaintenanceTwo {
    background: #fafafa !important;
    padding: 63px 0 45px 14px;
    .content_picture{
      img{
        max-width: 450px;
        max-height: 432px;
      }
    }
  }

  .equipment_operationMaintenances {
    img {
      width: auto;
      height: auto;
      max-width: 782px;
      max-height: 413px;
    }
  }

  //核心功能
  .content_space {
    background: #fafafa;
    h3 {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 21px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHeiLight;
      margin: auto;
    }
    .content {
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #000000;
        margin: 13px 0 14px 0;
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  metaInfo: {
    title: "智慧物管-WIDEN桅灯智能",
    meta: [
      {
        name: "keyWords",
        content: "智慧物管,桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
      },
      {
        name: "description",
        content: "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能智慧物管：可视-动态、直观的数字孪生技术对建筑设备进行全方位监测；可管-客服、设备、工单、巡检实时在线；可控-主动预警、即时响应、进度可查",
      },
    ],
  },
  data() {
    return {
      tabIndex: "2-2",
    };
  },
  methods: {},
  computed: {},
};
</script>